<template>
  <div class="index" v-loadmore="weekNewestLoadMore">
    <back></back>
    <div class="index-content" v-show="!showLoading">
      <router-link tag="div" to="/index/search/reset/focus" class="search">
        <search-fake placeholder="搜索专家、课程"></search-fake>
      </router-link>
      <!-- banner轮播 -->
      <div v-if="sliderList.length" class="slider-wrapper" ref="sliderWrapper">
        <swiper :indexConfig="0" :interval="sliderInterval">
          <swiper-item v-for="(item, i) in sliderList" :key="i">
            <template v-if="item.url.indexOf('http') === -1">
              <a>
                <router-link tag="img" :to="item.url" :src="item.pic"></router-link>
              </a>
            </template>
            <template v-else>
              <a :href="item.url">
                <img :src="item.pic" />
              </a>
            </template>
          </swiper-item>
        </swiper>
      </div>
      <!-- 分类导航 -->
      <div class="top-nav">
        <ul class="clearfix">
          <li v-for="(item, index) in todayColumn" :key="index">
            <router-link tag="div" class="col-wrap" :to="item.url" v-if="item.url.indexOf('http') === -1">
              <img :src="item.desc_images" alt="">
            </router-link>
            <a class="col-wrap" v-else :href="item.url">
              <img :src="item.desc_images" alt="">
            </a>
          </li>
          <!-- <li>
            <img class="icon" src="@/common/image/nav-1.png" alt="">
            <div class="name">精品推荐</div>
          </li>
          <li>
            <img class="icon" src="@/common/image/nav-2.png" alt="">
            <div class="name">大咖推荐</div>
          </li>
          <li>
            <img class="icon" src="@/common/image/nav-3.png" alt="">
            <div class="name">限时免费</div>
          </li>
          <li>
            <img class="icon" src="@/common/image/nav-4.png" alt="">
            <div class="name">X431</div>
          </li> -->
        </ul>
      </div>
      <!-- 今日推荐 -->
      <!-- 里面会初始化swiper, 这个v-if 不能去掉 -->
      <div class="today-push" v-if="todayPush.length">
        <div class="title">今日课程</div>
        <div class="swiper-wrap">
          <swiper :indexConfig="1" class="swiper">
            <swiper-item v-for="(item, index) in todayPush" :key="index" style="width:92%;" class="swiper-item">
              <router-link tag="div" class="item" :to="item.url" v-if="item.rec_type == 1">
                <div class="img-wrap">
                  <img :src="item.desc_images" alt="">
                </div>
                <div class="con">
                  <div class="name">{{item.title}}</div>
                  <div class="teacher">{{item.teacher_name}}</div>
                  <div class="intro">{{item.teacher_honer}}</div>
                </div>
              </router-link>
              <a class="item link" v-else :href="item.url">
                <img :src="item.desc_images" alt="">
              </a>
            </swiper-item>
          </swiper>
        </div>
      </div>
      <!-- 猜你喜欢 -->
      <div class="block">
        <div class="title">
          热门课程<a to="" href="javascript:;" @click="refreshPrefer"><i class="iconfont icon-huanyihuan"></i>换一换</a>
        </div>
        <div style="min-height:24px;">
          <card-course v-for="item in preferData" :key="item.id" :data="item"></card-course>
        </div>
      </div>
      <!-- 本周新课排行 -->
      <!--<div class="block">-->
        <!--<div class="title">-->
          <!--本周新课排行<router-link to="/index/search/reset">查看更多<i class="iconfont icon-mjiantou"></i></router-link>-->
        <!--</div>-->
        <!--<div style="min-height:24px;">-->
          <!--<card-course v-for="item in weekNewest" :key="item.id" :data="item"></card-course>-->
        <!--</div>-->
      <!--</div>-->
      <!-- 明星讲师 -->
      <div class="block">
        <div class="title">
          明星讲师<router-link to="/daka">更多大咖<i class="iconfont icon-mjiantou"></i></router-link>
        </div>
        <div class="daka-list">
          <router-link tag="div" class="item" v-for="item in dkList" :key="item.id" :to="'/daka/'+item.id">
            <div class="img-wrap">
              <img v-lazy="item.icon" alt="">
            </div>
            <div class="name">{{item.name}}</div>
          </router-link>
        </div>
      </div>
      <div class="block">
        <div class="title">课程列表</div>
        <div style="min-height:24px;">
          <card-course v-for="item in weekNewest" :key="item.id" :data="item"></card-course>
        </div>
        <loading2 :more="weekNewestMore" :loaded="weekNewestLoaded"></loading2>
      </div>
    </div>
    <loading v-show="showLoading||refreshingPrefer"></loading>
    <tab></tab>
    <!-- 引导绑定手机号码 -->
    <bind-phone v-if="isWeixin&&false"></bind-phone>
    <!-- 广告弹框 -->
    <ad-popup></ad-popup>
  </div>
</template>
<script type="text/ecmascript-6">
import axios from 'axios'
import {isWeixin} from '@/common/js/util'
import {RES_OK} from '@/api/config'
import Config from '@/utils/config'
import {getBannerList, getTjdk, getYouPrefer, getTodayPush, getTodayColumn, getWeekNewest} from '@/api/index'
import Tab from '@/components/tab/tab'
// import Slider from '../base/slider/slider'
import Swiper from '../base/swiper/swiper'
import SwiperItem from '../base/swiper/swiper-item'
import CardCourse from '../card/card-course'
import SearchFake from '../base/search/search-fake'
import Loading from '../base/loading/loading.vue'
import BindPhone from '@/components/base/activity/bindphone'
import AdPopup from '@/components/base/ad-popup'
import Loading2 from '../base/loading/loading2'
import back from '@/components/base/ui/back.vue'
export default {
  name: 'page-index',
  data() {
    return {
      needInit: false, // 是否已经初始化拉取数据了
      showLoading: true,
      sliderList: [], // 轮播数据
      sliderInterval: 4000, // 轮播间隔
      // 推荐大咖
      dkList: [],
      // 猜你喜欢
      preferData: [],
      refreshingPrefer: false,
      // 栏目推荐
      todayColumn: [],
      // 今日推荐
      todayPush: [],
      // 本周最新
      weekNewest: [],
      // 是否是微信环境
      isWeixin,
      weekNewestLoaded: false,
      weekNewestMore: true,
      weekNewestList: [],
      weekNewestPage: 1
    }
  },
  created() {
    // console.log(this.$store)
    // 同时执行多个请求
    if (Config.inUrl) {
      this.$router.push({
        path: Config.inUrl,
        query: Config.query
      })
      // 使用后就清除掉
      Config.inUrl = null
      Config.query = null
      // 页面activated 时候再加载数据
      this.$nextTick(() => {
        // 延迟，这样可以跳过 第一次 activated
        // 组件第一次初始化时 created 和 activated 是同时调用的
        this.needInit = true
      })
    } else {
      this.init()
    }
  },
  activated() {
    if (this.needInit) {
      // 需要加载数据
      this.init()
      this.needInit = false
    }
  },
  methods: {
    // 拉取数据的总方法
    // 前3个接口同步显示出来
    init() {
      axios.all([
        getBannerList(),
        getTodayColumn(),
        getTodayPush()
        // getYouPrefer(),
        // getWeekNewest(),
        // getTjdk()
      ]).then(axios.spread((
        bannerData,
        todayColumn,
        todayPush
        // preferData,
        // weekNewest,
        // tjdkData
      ) => {
        // 隐藏加载中
        this.showLoading = false
        // 提取banner数据
        this.setBannerList(bannerData.data)
        // 栏目推荐
        this.setTodayColumn(todayColumn.data)
        // 今日推荐数据
        this.setTodayPush(todayPush.data)
        // // 猜你喜欢数据
        // this.setPrefer(preferData.data)
        // // 本周最新
        // this.setWeekNewest(weekNewest.data)
        // // 提取推荐大咖数据
        // this.setTjdkList(tjdkData.data)
      })).catch(err => {
        console.log(err)
      })
      getYouPrefer().then(({data}) => {
        // 猜你喜欢数据
        this.setPrefer(data)
      })
      this._getWeekNewest()
      getTjdk().then(({data}) => {
        // 提取推荐大咖数据
        this.setTjdkList(data)
      })
    },
    // 提取banner数据
    setBannerList(bannerData) {
      if (bannerData.code === RES_OK) {
        this.sliderList = bannerData.data.content
        this.sliderInterval = bannerData.data.period * 1000
      }
    },
    // 提取推荐大咖数据
    setTjdkList(tjdkData) {
      if (tjdkData.code === RES_OK) {
        this.dkList.push(...tjdkData.data)
      }
    },
    // 猜你喜欢
    setPrefer(preferData) {
      if (preferData.code === RES_OK) {
        this.preferData = preferData.data
      }
    },
    refreshPrefer() {
      // 换一换
      if (this.refreshingPrefer) return
      this.refreshingPrefer = true
      getYouPrefer().then(({data}) => {
        this.refreshingPrefer = false
        this.setPrefer(data)
      })
    },
    setTodayPush(todayPush) {
      if (todayPush.code === RES_OK) {
        this.todayPush = todayPush.data
      }
    },
    setTodayColumn(todayColumn) {
      if (todayColumn.code === RES_OK) {
        this.todayColumn = todayColumn.data
      }
    },
    _getWeekNewest() {
      getWeekNewest(this.weekNewestPage).then(({data}) => {
        if (data.code === RES_OK) {
          this.weekNewest.push(...data.data)
          this.weekNewestLoaded = true
          this.weekNewestPage++
          // 加载完毕
          this.weekNewestMore = data.data.length === 10
        }
      }).catch(() => {})
    },
    weekNewestLoadMore() {
      if (this.weekNewestMore && this.weekNewestLoaded) {
        this.weekNewestLoaded = false
        this._getWeekNewest()
      }
    }
  },
  components: {
    Tab,
    // Slider,
    Swiper,
    SwiperItem,
    SearchFake,
    Loading,
    CardCourse,
    BindPhone,
    AdPopup,
    Loading2,
    back
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .index {
    width: 100%
    background #efeff3
    .index-content {
      font-size: size(26)
      padding-bottom: size(110)
      .search {
        background #fff
        padding size(18) size(30)
      }
      .slider-wrapper {
        overflow hidden
        height size(300)
        a{
          display block
          height 100%
        }
        img{
          display block
          height 100%
          width 100%
        }
      }
      .block{
        background #ffffff
        margin-top size(10)
        padding 0 size(30)
        overflow hidden
        .title {
          font-size size(38)
          font-weight 800
          position relative
          padding-left size(14)
          margin-top size(44)
          a {
            position absolute
            right 0
            bottom 50%
            font-size size(24)
            transform translateY(50%)
            color #666
          }
          .iconfont{
            font-size 10px
            margin-left 1px
            &.icon-huanyihuan{
              margin-right 4px
            }
          }
          &:before{
            content ' '
            display block
            left 0
            top 50%
            width size(7)
            height size(24)
            margin-top size(-12)
            position absolute
            background $color-theme
          }
        }
      }
    }
  }
  .vip-label{
    background linear-gradient(to right, $color-vip, lighten($color-vip, 32%))
    display inline-block
    color #fff
    font-size 12px
    font-weight 500
    padding 2px 4px
    border-radius 4px
    margin-left 4px
    vertical-align top
    margin-top 1px
  }
  /* 顶部的分类导航 */
  .top-nav{
    background #ffffff
    padding size(30) size(30) size(14)
    font-size 0
    margin-left -2%
    li{
      float left
      margin-left 2%
      width 23%
      // min-height size(100)
      // border 1px solid #c0c0c0
      border-radius 4px
      text-align center
      box-shadow: 0 1px 2.5px 0px rgba(189,189,189,0.5)
    }
    img.icon{
      width size(42)
      margin size(10) 0 size(8)
    }
    .name{
      font-size size(28)
      color #2e2e2e
      font-weight 800
    }
    .col-wrap{
      display block
      width 100%
      img{
        display block
        width 100%
      }
    }
  }
  /* 今日推荐 */
  .today-push{
    padding-left size(30)
    overflow hidden
    background #fff
    .title{
      font-size size(38)
      font-weight 800
      color #30302e
      padding size(30) 0
    }
    .swiper-wrap{
      min-height size(228)
      overflow hidden
    }
    .swiper{
      height size(174)
      padding-bottom 15px
      padding-left 3px
      box-sizing content-box
    }
    .swiper-item{
      width 92%
    }
    .item{
      display block
      // border 1px solid #c0c0c0
      background-image url('~@/common/image/border.png')
      background-size 100% 100%
      border-radius 4px
      height 100%
      box-shadow: 0 1px 2.5px 0px rgba(189,189,189,0.5)
      padding size(16)
      .img-wrap{
        float left
        width 19.5%
        height 100%
        img{
          width 100%
          height 100%
          border none
        }
      }
      .con{
        float left
        width 80.4%
        padding-left size(20)
      }
      .name,.teacher{
        font-size size(28)
        font-weight 800
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        line-height 1.4
      }
      .teacher{
        font-weight 500
        font-size size(26)
        color #000
        margin size(14) 0
      }
      .intro{
        color #8a8a8a
        font-size size(22)
        margin-top size(4)
      }
      &.link{
        img{
          width 100%
          height 100%
          display block
        }
      }
    }
  }
  .daka-list{
    margin-top size(48)
    padding 0 size(12) size(4)
    margin-left -8%
    .item{
      margin-bottom size(40)
      float left
      width 12%
      margin-left 8%
      text-align center
      .img-wrap{
        position relative
        padding-bottom 100%
        img{
          position absolute
          width 100%
          height 100%
          left 0
          top 0
        }
      }
      .name{
        font-size size(24)
        color #0c0c0c
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        margin-top size(20)
      }
    }
    &:after{
      content ' '
      display block
      height 0
      clear both
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue